import React, { useState } from 'react';
import axios from 'axios';
import Header from './Header';
import Footer from './Footer';
import './Signup.css';
import { Link } from 'react-router-dom';
import Signup1 from '../src/images/Signup1.png';

const Signup = () => {
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [username, setUsername] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (password !== confirmPassword) {
            setErrorMessage('Passwords do not match.');
            return;
        }

        try {
            const response = await axios.post('https://api.abhyaranyan.com/api/Signup/Registration', {
                id: "",
                firstName,
                lastName,
                username,
                phonenumber: phoneNumber,
                email,
                password,
                confirmPassword
            });

            if (response.data.succeeded) {
                setSuccessMessage('Account created successfully!');
                setErrorMessage('');
                // Handle successful registration (e.g., redirect to login page)
            } else {
                setErrorMessage(response.data.message || 'Registration failed.');
                setSuccessMessage('');
            }
        } catch (error) {
            setErrorMessage('An error occurred. Please try again.');
            setSuccessMessage('');
        }
    };

    return (
        <div>
            <Header />
            <section className="breadcrumb-section pt-0">
                <img
                    src={Signup1}
                    className="bg-img img-fluid blur-up lazyload"
                    alt=""
                />
                <div className="breadcrumb-content">
                    <div>
                        <h2>sign up</h2>
                        <nav aria-label="breadcrumb" className="theme-breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <a href="index.html">Home</a>
                                </li>
                                <li className="breadcrumb-item active" aria-current="page">
                                    sign up
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
                <div className="title-breadcrumb">Rica</div>
            </section>

            <section className="section-b-space dark-cls animated-section">
                <div className="background-image">
                    <img src="../assets/images/cab/grey-bg.jpg" alt="" className="img-fluid blur-up lazyload bg-img" />
                </div>
                <div className="overlay">
                    <div className="animation-section">
                        <div className="cross po-1"></div>
                        <div className="cross po-2"></div>
                        <div className="round po-4"></div>
                        <div className="round po-5"></div>
                        <div className="round r-y po-8"></div>
                        <div className="square po-10"></div>
                        <div className="square po-11"></div>
                    </div>
                    <div className="container">
                        <div className="row">
                            <div className="offset-lg-3 col-lg-6 offset-sm-2 col-sm-8 col-12">
                                <div className="account-sign-in">
                                    <div className="title">
                                        <h3>sign up</h3>
                                    </div>
                                    <form onSubmit={handleSubmit}>
                                        <div className="form-group" style={{ textAlign: "left" }}>
                                            <label htmlFor="firstName">First Name</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="firstName"
                                                placeholder="Enter your First Name"
                                                style={{ textAlign: "left" }}
                                                value={firstName}
                                                onChange={(e) => setFirstName(e.target.value)}
                                            />
                                        </div>
                                        <div className="form-group" style={{ textAlign: "left" }}>
                                            <label htmlFor="lastName">Last Name</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="lastName"
                                                placeholder="Enter your Last Name"
                                                style={{ textAlign: "left" }}
                                                value={lastName}
                                                onChange={(e) => setLastName(e.target.value)}
                                            />
                                        </div>
                                        <div className="form-group" style={{ textAlign: "left" }}>
                                            <label htmlFor="username">User Name</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="username"
                                                placeholder="Enter your User Name"
                                                style={{ textAlign: "left" }}
                                                value={username}
                                                onChange={(e) => setUsername(e.target.value)}
                                            />
                                        </div>
                                        <div className="form-group" style={{ textAlign: "left" }}>
                                            <label htmlFor="phoneNumber">Phone Number</label>
                                            <input
                                                type="tel"
                                                className="form-control"
                                                id="phoneNumber"
                                                placeholder="Enter your Phone Number"
                                                style={{ textAlign: "left" }}
                                                value={phoneNumber}
                                                onChange={(e) => setPhoneNumber(e.target.value)}
                                            />
                                        </div>
                                        <div className="form-group" style={{ textAlign: "left" }}>
                                            <label htmlFor="email">Email address</label>
                                            <input
                                                type="email"
                                                className="form-control"
                                                id="email"
                                                placeholder="Enter email address"
                                                style={{ textAlign: "left" }}
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                            />
                                            <small id="emailHelp" className="form-text text-muted">We'll never share your email with anyone else.</small>
                                        </div>
                                        <div className="form-group" style={{ textAlign: "left" }}>
                                            <label htmlFor="password">Password</label>
                                            <input
                                                type="password"
                                                className="form-control"
                                                id="password"
                                                placeholder="Password"
                                                style={{ textAlign: "left" }}
                                                value={password}
                                                onChange={(e) => setPassword(e.target.value)}
                                            />
                                        </div>
                                        <div className="form-group" style={{ textAlign: "left" }}>
                                            <label htmlFor="confirmPassword">Confirm Password</label>
                                            <input
                                                type="password"
                                                className="form-control"
                                                id="confirmPassword"
                                                placeholder="Confirm Password"
                                                style={{ textAlign: "left" }}
                                                value={confirmPassword}
                                                onChange={(e) => setConfirmPassword(e.target.value)}
                                            />
                                        </div>
                                        <div className="form-group form-check" style={{ textAlign: "left" }}>
                                            <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                                            <label className="form-check-label" htmlFor="exampleCheck1">Remember me</label>
                                        </div>
                                        {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
                                        {successMessage && <div className="alert alert-success">{successMessage}</div>}
                                        <div className="button-bottom">
                                            <button type="submit" className="w-100 btn btn-solid">Create Account</button>
                                            <div className="divider">
                                                <h6>or</h6>
                                            </div>
                                            <Link to="/Profilelogin">
                                                <button type="button" className="w-100 btn btn-solid btn-outline">
                                                    Login
                                                </button>
                                            </Link>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    );
};

export default Signup;
